import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { User } from "lucide-react";

const NavBar = () => {
  const { count, open } = useCart();
  const { isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  const linkCls = (path) =>
    `font-condensed text-base md:text-lg uppercase tracking-widest transition-colors ${
      location.pathname === path ? "text-[#D95D39]" : "hover:text-[#D95D39]"
    }`;

  return (
    <header
      className="sticky top-0 z-40 bg-[#FFFDF5] border-b-4 border-[#1C1914]"
      data-testid="navbar"
    >
      <div className="flex items-center justify-between px-4 md:px-8 py-3">
        <Link
          to="/"
          className="font-display text-2xl md:text-3xl tracking-tighter"
          data-testid="nav-brand"
        >
          DUDS<span className="text-[#D95D39]">.</span>
        </Link>
        <nav className="hidden md:flex gap-8 items-center" aria-label="Primary">
          <Link to="/" className={linkCls("/")} data-testid="nav-shop">Shop</Link>
          <Link to="/lookbook" className={linkCls("/lookbook")} data-testid="nav-lookbook">
            Lookbook
          </Link>
          <Link to="/story" className={linkCls("/story")} data-testid="nav-story">
            Story
          </Link>
        </nav>
        <div className="flex items-center gap-2">
          <Link
            to={isAuthenticated ? (isAdmin ? "/admin" : "/account") : "/login"}
            className="inline-flex items-center gap-1.5 border-2 border-[#1C1914] px-3 py-2 font-condensed uppercase tracking-widest text-sm hover:bg-[#FDE047] transition-colors"
            aria-label={isAuthenticated ? "My account" : "Log in"}
            data-testid="nav-account-button"
          >
            <User size={16} />
            <span className="hidden sm:inline">{isAuthenticated ? (isAdmin ? "Admin" : "Account") : "Log in"}</span>
          </Link>
          <button
            type="button"
            onClick={open}
            className="relative inline-flex items-center gap-2 border-2 border-[#1C1914] px-3 py-2 font-condensed uppercase tracking-widest text-sm md:text-base shadow-hard-sm hover:bg-[#FDE047] transition-colors"
            aria-label="Open cart"
            data-testid="nav-cart-button"
          >
            Cart
            <span
              className="inline-flex items-center justify-center bg-[#1C1914] text-[#FFFDF5] min-w-[24px] px-1.5 py-0.5 text-xs font-display"
              data-testid="nav-cart-count"
            >
              {count}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
